module.exports = __webpack_public_path__ + "img/migrating.092a1cee.svg";